/* ============================================================
   PR-QUIZ v2 — Lógica completa
   ============================================================ */

const PR_QUIZ_FLOW = [
  'entry', 'intro', '1', 'interlude1',
  '2', '3', '4', '5', 'trans2',
  '6', '7', '8', '9', 'interlude2',
  '11', '12', 'interlude3', 'result'
];

const PR_QUIZ_QUESTIONS = ['1','2','3','4','5','6','7','8','9','11','12'];
const PR_QUIZ_TOTAL_Q = PR_QUIZ_QUESTIONS.length;

const PR_QUIZ_PHASE_MAP = {
  '1':1, 'interlude1':1, '2':1, '3':1, '4':1, '5':1,
  'trans2':2, '6':2, '7':2, '8':2, '9':2, 'interlude2':2,
  '11':3, '12':3, 'interlude3':3, 'result':3
};

const PR_PRODUCT_DATA = {
  reforco_corp:  { name: 'Hidratante Corporal Reforço Protetor 200g', desc: 'Textura reconstrutora para peles em crise. Tecnologia BioCic com ativos vegetais de alta penetração celular.', key: 'reforco-corp' },
  reforco_facial:{ name: 'Loção Facial Reforço Protetor 60g',         desc: 'Textura cremosa reconstrutora para rosto sensível. Sem essências, sem corantes, sem irritantes.', key: 'reforco-facial' },
  alto_corp:     { name: 'Hidratante Corporal de Alto Desempenho 200g',desc: 'Textura cremosa leve para pele oleosa ou mista. Hidratação sem oclusão excessiva.', key: 'alto-corp' },
  alto_facial:   { name: 'Loção Facial de Alto Desempenho 60g',        desc: 'Textura fluida aveludada para rosto oleoso ou misto. Leve e de rápida absorção.', key: 'alto-facial' },
  spray:         { name: 'Spray Dermoconstrutor 60ml',                 desc: 'Aplicação sem toque para peles extremamente sensíveis. Formulação em spray para pós-sol, pós-cirurgia e lesão por pressão.', key: 'spray' },
  serum:         { name: 'Sérum Noturno para Couro Cabeludo 60ml',     desc: 'Uso noturno para couro cabeludo sensível. Ativos que atuam durante o ciclo de renovação celular.', key: 'serum' },
  espuma:        { name: 'Espuma Facial Sensação Ultra-leve 150ml',    desc: 'Higiene facial delicada. Tecnologia BioBloc sem agentes agressivos.', key: 'espuma' },
  sabonete:      { name: 'Sabonete Líquido Corporal Ultra-leve 250ml', desc: 'Limpeza corporal suave para pele sensível. Sem detergentes agressivos.', key: 'sabonete' }
};

const PR_CONDITION_LABELS = {
  dermatite: 'Dermatite ou eczema',
  psoriase:  'Psoríase',
  vitiligo:  'Vitiligo ou hipocromia',
  rosaca:    'Rosácea',
  quimio:    'Pele em tratamento com quimioterapia',
  radioterapia: 'Pele em tratamento com radioterapia',
  cirurgia:  'Pós-cirurgia ou pós-procedimento',
  pos_sol:   'Queimadura solar ou pós-sol',
  idade50:   'Pele madura (50+ anos)',
  lesao_pressao: 'Prevenção de lesão por pressão',
  pele_seca: 'Pele ultra seca',
  pele_sensivel: 'Pele sensível sem diagnóstico'
};

const PR_CONDITION_SUMMARIES = {
  dermatite:    'Suporte para barreira cutânea comprometida por dermatite',
  psoriase:     'Formulação limpa para pele com dinâmica de renovação alterada por psoríase',
  vitiligo:     'Protocolo sem gatilhos inflamatórios para pele com vitiligo',
  rosaca:       'Hidratação sem essências nem corantes para pele com rosácea',
  quimio:       'Formulação segura para pele sensibilizada por quimioterapia',
  radioterapia: 'Suporte à barreira comprometida pela radioterapia',
  cirurgia:     'Protocolo de recuperação para pele pós-cirurgia',
  pos_sol:      'Recuperação da barreira após queimadura solar',
  idade50:      'Formulação reconstrutora para pele madura com produção lipídica reduzida',
  lesao_pressao:'Prevenção ativa da lesão por pressão',
  pele_seca:    'Reposição lipídica profunda para pele ultra seca',
  pele_sensivel:'Hidratação limpa para pele sensível sem gatilhos de irritação'
};

const PR_REACTION_SUMMARIES = {
  alta:  'Alta sensibilidade — arde ou coça com a maioria dos produtos',
  media: 'Sensibilidade moderada — reage com facilidade ao contato',
  baixa: 'Sensibilidade controlada — tolera a maioria sem reação'
};

const PR_OBJECTIVE_SUMMARIES = {
  barreira:   'Recuperação da barreira cutânea comprometida',
  vermelhidao:'Redução de vermelhidão, coceira e descamação',
  hidratacao: 'Hidratação profunda sem irritação',
  prevencao:  'Manutenção preventiva de longo prazo'
};

const PR_FAQ_BY_CONDITION = {
  dermatite: [
    { q: 'Por que minha pele arde com produtos comuns?', a: 'Peles com dermatite têm barreira cutânea comprometida, o que permite que ingredientes comuns — como essências, conservantes e surfactantes — penetrem mais profundamente e gerem resposta inflamatória. A formulação BioCic não contém esses gatilhos.' },
    { q: 'Posso usar junto com corticoide tópico?', a: 'O produto é cosmético e pode ser utilizado em conjunto com prescrições médicas. Em caso de dúvida, consulte seu dermatologista antes de iniciar.' },
    { q: 'Em quanto tempo vejo resultado?', a: 'Peles com dermatite ativa geralmente percebem redução do desconforto nas primeiras semanas. A barreira cutânea se fortalece com o uso contínuo ao longo de 4 a 6 semanas.' },
    { q: 'O produto tem algum ativo que pode irritar?', a: 'Não. A formulação não contém essências, corantes, parabenos, lanolina ou álcool desnaturado — os gatilhos mais comuns de irritação em peles com dermatite.' }
  ],
  psoriase: [
    { q: 'O produto trata a psoríase?', a: 'Não. A Pele Rara é cosmética e atua como coadjuvante no cuidado da pele. Não substitui tratamento médico nem promete controle da condição.' },
    { q: 'Pode usar nas placas ativas?', a: 'O produto foi desenvolvido para pele sensível e sensibilizada. Em áreas com lesão ativa, recomendamos consultar o dermatologista antes do uso.' },
    { q: 'Por que sem essências?', a: 'Essências são gatilhos diretos de inflamação em peles reativas. A ausência total de essências reduz significativamente o risco de reação e irritação.' }
  ],
  vitiligo: [
    { q: 'O produto interfere na melanina?', a: 'Não. A formulação não contém ativos despigmentantes nem despigmentantes. Ela foca em manter a barreira cutânea íntegra e hidratada.' },
    { q: 'Posso usar na área tratada com fototerapia?', a: 'Em regiões tratadas com fototerapia, consulte seu médico antes de usar qualquer cosmético, incluindo produtos BioCic.' },
    { q: 'Tem algum ingrediente que eu devo evitar?', a: 'Nenhum. Sem essências, corantes, parabenos ou conservantes agressivos.' }
  ],
  rosaca: [
    { q: 'Por que rosácea precisa de formulação sem essências?', a: 'Essências são um dos gatilhos mais documentados de crise de rosácea. A ausência total de fragrâncias elimina esse fator de risco.' },
    { q: 'O produto tem sensação de calor na aplicação?', a: 'Não. A formulação foi desenvolvida para não gerar sensação de ardor, calor ou formigamento, comuns em peles com rosácea reativa.' },
    { q: 'Posso usar no cotidiano?', a: 'Sim. O protocolo foi desenvolvido para uso diário, sem acúmulo e sem sobrecarga para peles reativas.' }
  ],
  quimio: [
    { q: 'É seguro usar durante o tratamento oncológico?', a: 'O produto é cosmético e não interfere no tratamento oncológico. Recomendamos validar o uso com a equipe médica responsável antes de iniciar.' },
    { q: 'Posso usar na região tratada com quimio?', a: 'Em regiões com dermatite induzida por quimioterapia, o uso deve ser discutido com o oncologista ou enfermeiro de suporte oncológico.' },
    { q: 'O produto tem algum ingrediente preocupante para imunossuprimidos?', a: 'Não. A formulação não contém ingredientes que apresentem risco documentado para pacientes em tratamento quimioterápico. Mas sempre valide com sua equipe médica.' }
  ],
  radioterapia: [
    { q: 'Posso aplicar na região irradiada?', a: 'Em regiões sob tratamento radioterápico ativo, consulte sempre a equipe médica antes de aplicar qualquer produto tópico.' },
    { q: 'O produto ajuda com a descamação da radiodermite?', a: 'A formulação suporta a integridade da barreira cutânea e pode contribuir para o conforto da pele sensibilizada pela radiação, sempre como coadjuvante.' },
    { q: 'Tem alguma contraindicação conhecida?', a: 'A formulação é livre de ingredientes reconhecidamente contraindicados em pele irradiada. Valide o uso com a equipe de radioterapia.' }
  ],
  cirurgia: [
    { q: 'Quando posso começar a usar após a cirurgia?', a: 'A indicação de início deve ser feita pelo cirurgião responsável, que avaliará a integridade da área operada. Não use em feridas abertas.' },
    { q: 'O produto ajuda na cicatrização?', a: 'A tecnologia BioCic foi validada em modelo ex vivo de cicatrização de pele humana, com resultados de suporte ao fechamento de feridas. O produto é cosmético e não promete resultado terapêutico.' },
    { q: 'Posso usar no rosto após procedimento estético?', a: 'Sim, após liberação do profissional responsável pelo procedimento. A formulação é livre de ingredientes agressivos para pele sensibilizada.' }
  ],
  pos_sol: [
    { q: 'Posso usar logo após a queimadura solar?', a: 'Sim. O produto foi desenvolvido para pele sensibilizada e pode ser aplicado em pele eritematosa por exposição solar. Evite áreas com bolhas ou descamação ativa intensa.' },
    { q: 'O produto tem filtro solar?', a: 'Não. A formulação é um hidratante para uso após a exposição. Para proteção, use protetor solar adequado antes da exposição.' },
    { q: 'Ajuda com a descamação do pós-sol?', a: 'Sim. A base lipídica da tecnologia BioCic suporta a recuperação da barreira e pode reduzir a descamação associada à queimadura solar.' }
  ],
  idade50: [
    { q: 'Por que peles maduras precisam de formulação diferente?', a: 'A partir dos 50 anos, a produção natural de ceramidas, ácidos graxos e esqualeno reduz significativamente. A textura reconstrutora do Reforço Protetor repõe essa carência lipídica.' },
    { q: 'O produto tem ativos antiaging?', a: 'A formulação não é posicionada como antiaging. Ela foca em manter a barreira cutânea íntegra, hidratada e funcional — o que é base para qualquer outro resultado na pele madura.' },
    { q: 'Pode usar no contorno dos olhos?', a: 'Sim, a formulação é segura para a área periorbital. Evite contato direto com os olhos.' }
  ],
  lesao_pressao: [
    { q: 'Qual é o papel do cosmético na prevenção de lesão por pressão?', a: 'Manter a pele hidratada e com barreira íntegra reduz o risco de lesão por pressão, especialmente em regiões ósseas de maior atrito.' },
    { q: 'Com que frequência aplicar?', a: 'Recomenda-se pelo menos uma aplicação diária, com atenção especial às regiões de maior pressão. A equipe de enfermagem pode orientar sobre a frequência ideal para cada caso.' },
    { q: 'Pode ser usado por pacientes acamados?', a: 'Sim. A formulação é gentil para pele frágil e não contém ingredientes que aumentem o risco de irritação ou alergia em pacientes fragilizados.' }
  ],
  pele_seca: [
    { q: 'Em que o BioCic é diferente de um hidratante de farmácia?', a: 'Hidratantes convencionais geralmente usam ingredientes oclusivos (como vaselina ou parafina) que criam uma barreira superficial. A tecnologia BioCic entrega ativos naturais a nível celular, com penetração documentada em estudo clínico.' },
    { q: 'Preciso usar todos os dias?', a: 'Para pele ultra seca, o uso diário é o mais indicado. Você perceberá a diferença na textura após alguns dias de uso contínuo.' },
    { q: 'O produto tem uréia ou ácido lático?', a: 'Não. A formulação não usa queratoliticos. A hidratação acontece pelo suporte à barreira lipídica com ácidos graxos essenciais — mecanismo diferente dos hidratantes convencionais.' }
  ],
  pele_sensivel: [
    { q: 'Qual a diferença para um produto "para pele sensível" de farmácia?', a: 'A maioria dos produtos rotulados como "para pele sensível" ainda contém essências mascaradas, conservantes comuns e corantes. A Pele Rara é livre de todos esses ingredientes — o que é validado na formulação, não apenas no rótulo.' },
    { q: 'Posso usar mesmo sem diagnóstico médico?', a: 'Sim. O produto é cosmético e seguro para uso em pele sensível sem diagnóstico específico.' },
    { q: 'O que é a tecnologia BioCic?', a: 'BioCic é uma nanotecnologia patenteada desenvolvida pela Dra. Cynthia Nara na FCFRP-USP. Ela empacota ativos naturais em nanopartículas que penetram a barreira da pele e entregam os ativos a nível celular.' }
  ]
};

function resolveProduct(answers, container) {
  const q1 = answers.q1 || 'pele_sensivel';
  const q3 = answers.q3 || 'corpo';
  const q4 = answers.q4 || 'nao_sei';

  const isScalp = q3 === 'couro_cabeludo';
  const isSprayCondition = ['pos_sol','cirurgia','lesao_pressao'].includes(q1);
  const isOily = q4 === 'oleosa';
  const isFace = q3 === 'rosto';

  const get = (key) => container.dataset[`prod${key.replace(/-/g,'').replace(/([A-Z])/g, c => c).replace(/[A-Z]/g, c => c.toLowerCase())}`]
    || container.getAttribute(`data-prod-${key}`);

  if (isScalp) {
    return { product: PR_PRODUCT_DATA.serum, url: get('serum') || '/products/serum-capilar-noturno-de-alta-performance', complements: ['espuma'], productKey: 'serum' };
  }

  if (isSprayCondition) {
    const comp = isFace ? ['reforco_facial','espuma'] : ['reforco_corp','espuma'];
    return { product: PR_PRODUCT_DATA.spray, url: get('spray') || '/products/spray-dermoconstrutor-de-alto-desempenho', complements: comp, productKey: 'spray' };
  }

  if (isOily) {
    if (isFace) return { product: PR_PRODUCT_DATA.alto_facial, url: get('alto-facial') || '/products/locao-dermoconstrutora-facial-de-alto-desempenho', complements: ['espuma'], productKey: 'alto_facial' };
    const comp = q3 === 'ambos' ? ['sabonete','espuma'] : ['sabonete'];
    return { product: PR_PRODUCT_DATA.alto_corp, url: get('alto-corp') || '/products/hidratante-dermoconstrutor-corporal-de-alto-desempenho', complements: comp, productKey: 'alto_corp' };
  }

  if (isFace) {
    return { product: PR_PRODUCT_DATA.reforco_facial, url: get('reforco-facial') || '/products/locao-dermoconstrutora-facial-reforco-protetor', complements: ['espuma'], productKey: 'reforco_facial' };
  }

  const comp = q3 === 'ambos' ? ['sabonete','espuma'] : ['sabonete'];
  return { product: PR_PRODUCT_DATA.reforco_corp, url: get('reforco-corp') || '/products/hidratante-dermoconstrutor-corporal-reforco-protetor', complements: comp, productKey: 'reforco_corp' };
}

function getComplementUrl(key, container) {
  const map = {
    espuma: container.getAttribute('data-prod-espuma') || '/products/espuma-facial-de-alto-desempenho-sensacao-ultra-leve',
    sabonete: container.getAttribute('data-prod-sabonete') || '/products/sabonete-liquido-corporal-sesacao-ultra-leve',
    reforco_corp: container.getAttribute('data-prod-reforco-corp') || '/products/hidratante-dermoconstrutor-corporal-reforco-protetor',
    reforco_facial: container.getAttribute('data-prod-reforco-facial') || '/products/locao-dermoconstrutora-facial-reforco-protetor'
  };
  return map[key] || '#';
}

class PeleRaraQuiz {
  constructor(container) {
    this.c = container;
    this.id = container.dataset.sectionId || '';
    this.webhookUrl = container.dataset.webhook || '';
    this.currentStep = 'entry';
    this.answers = {};
    this.multiAnswers = {};
    this.countdownInterval = null;
    this.countdownEnd = null;

    this.phasesEl = container.querySelector(`#prQuizPhases-${this.id}`);
    this.progressWrap = container.querySelector(`#prQuizProgressWrap-${this.id}`);
    this.progressBar = container.querySelector(`#prQuizProgressBar-${this.id}`);

    this._init();
  }

  _init() {
    this._hidePhaseBar();
    this._hideProgress();
    this._bindOptions();
    this._bindButtons();
    this._bindEmailForm();
    this._bindFaqToggle();
  }

  _step(id) {
    return this.c.querySelector(`.pr-quiz__step[data-step="${id}"]`);
  }

  _hidePhaseBar() {
    if (this.phasesEl) this.phasesEl.style.display = 'none';
  }

  _showPhaseBar() {
    if (this.phasesEl) this.phasesEl.style.display = '';
  }

  _hideProgress() {
    if (this.progressWrap) this.progressWrap.style.display = 'none';
  }

  _showProgress() {
    if (this.progressWrap) this.progressWrap.style.display = '';
  }

  _updateProgress(stepId) {
    const qIndex = PR_QUIZ_QUESTIONS.indexOf(stepId);
    if (qIndex >= 0 && this.progressBar) {
      this.progressBar.style.width = ((qIndex + 1) / PR_QUIZ_TOTAL_Q * 100) + '%';
    }
  }

  _updatePhase(stepId) {
    if (!this.phasesEl) return;
    const phase = PR_QUIZ_PHASE_MAP[stepId];
    if (!phase) return;
    this.phasesEl.querySelectorAll('.pr-quiz__phase').forEach(el => {
      const p = parseInt(el.dataset.phase);
      el.classList.toggle('active', p === phase);
      el.classList.toggle('done', p < phase);
    });
  }

  _goTo(nextStep) {
    const currentEl = this._step(this.currentStep);
    const nextEl = this._step(nextStep);
    if (!nextEl) return;

    if (nextStep === 'entry' || nextStep === 'result') {
      this._hidePhaseBar();
      this._hideProgress();
    } else {
      this._showPhaseBar();
      this._showProgress();
      this._updatePhase(nextStep);
      this._updateProgress(nextStep);
    }

    if (currentEl) {
      currentEl.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
      currentEl.style.opacity = '0';
      currentEl.style.transform = 'translateX(-16px)';
      setTimeout(() => {
        currentEl.classList.remove('active');
        currentEl.style.cssText = '';
        this.currentStep = nextStep;
        this._activateStep(nextEl, nextStep);
      }, 250);
    } else {
      this.currentStep = nextStep;
      this._activateStep(nextEl, nextStep);
    }
  }

  _activateStep(el, stepId) {
    el.classList.add('active');
    this._scrollToQuiz();

    if (stepId === 'interlude2') {
      this._runSummaryAnimation();
    } else if (stepId === 'result') {
      this._fillResult();
      this._startCountdown();
    }
  }

  _scrollToQuiz() {
    const top = this.c.getBoundingClientRect().top + window.scrollY - 10;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  _bindOptions() {
    this.c.querySelectorAll('.pr-quiz__option, .pr-quiz__card').forEach(btn => {
      btn.addEventListener('click', () => {
        const stepEl = btn.closest('.pr-quiz__step');
        const stepId = stepEl.dataset.step;
        const q = btn.dataset.q;
        const val = btn.dataset.value;
        const isMulti = btn.classList.contains('pr-quiz__option--multi');

        if (isMulti) {
          btn.classList.toggle('selected');
          if (!this.multiAnswers[q]) this.multiAnswers[q] = [];
          if (btn.classList.contains('selected')) {
            if (!this.multiAnswers[q].includes(val)) this.multiAnswers[q].push(val);
          } else {
            this.multiAnswers[q] = this.multiAnswers[q].filter(v => v !== val);
          }
          this.answers[q] = this.multiAnswers[q].join(',');
          return;
        }

        stepEl.querySelectorAll('.pr-quiz__option:not(.pr-quiz__option--multi), .pr-quiz__card').forEach(o => o.classList.remove('selected'));
        btn.classList.add('selected');
        this.answers[q] = val;

        if (stepId === '1') {
          this._showInterlude1(val);
        }

        const nextStep = this._nextStep(stepId);
        if (nextStep) {
          setTimeout(() => this._goTo(nextStep), 380);
        }
      });
    });
  }

  _nextStep(stepId) {
    if (['8'].includes(stepId)) return null;
    const idx = PR_QUIZ_FLOW.indexOf(stepId);
    return idx >= 0 ? PR_QUIZ_FLOW[idx + 1] : null;
  }

  _showInterlude1(condition) {
    const blocks = this.c.querySelectorAll(`[data-step="interlude1"] .pr-quiz__il-block`);
    blocks.forEach(b => {
      b.style.display = b.dataset.condition === condition ? '' : 'none';
    });
  }

  _bindButtons() {
    this.c.querySelectorAll('[data-goto]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = btn.dataset.goto;
        if (target) this._goTo(target);
      });
    });
  }

  _bindEmailForm() {
    const form = this.c.querySelector(`#prQuizEmailForm-${this.id}`);
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = this.c.querySelector(`#prQuizEmail-${this.id}`)?.value?.trim() || '';
      const whatsapp = this.c.querySelector(`#prQuizWhatsApp-${this.id}`)?.value?.trim() || '';
      this.answers.email = email;
      this.answers.whatsapp = whatsapp;
      if (this.webhookUrl) {
        try {
          await fetch(this.webhookUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, whatsapp, answers: this.answers, source: 'quiz-diagnostico-v2' })
          });
        } catch (_) {}
      }
      this._goTo('interlude3');
    });

    const discountBtn = this.c.querySelector(`#prQuizDiscountBtn-${this.id}`);
    if (discountBtn) {
      discountBtn.addEventListener('click', async () => {
        const emailEl = this.c.querySelector(`#prQuizDiscountEmail-${this.id}`);
        const email = emailEl?.value?.trim() || '';
        if (!email) { emailEl?.focus(); return; }
        if (this.webhookUrl) {
          try {
            await fetch(this.webhookUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email, answers: this.answers, source: 'quiz-desconto-20off' })
            });
          } catch (_) {}
        }
        discountBtn.textContent = 'Cupom enviado! Verifique seu e-mail.';
        discountBtn.disabled = true;
      });
    }

    const closeCountdown = this.c.querySelector(`#prQuizCountdownClose-${this.id}`);
    if (closeCountdown) {
      closeCountdown.addEventListener('click', () => {
        const box = this.c.querySelector(`#prQuizCountdown-${this.id}`);
        if (box) box.style.display = 'none';
        clearInterval(this.countdownInterval);
      });
    }
  }

  _bindFaqToggle() {
    this.c.addEventListener('click', (e) => {
      const btn = e.target.closest('.pr-quiz__faq-q');
      if (!btn) return;
      const item = btn.closest('.pr-quiz__faq-item');
      if (item) item.classList.toggle('open');
    });
  }

  _runSummaryAnimation() {
    const list = this.c.querySelector(`#prQuizSummaryList-${this.id}`);
    const summaryBtn = this.c.querySelector(`#prQuizSummaryBtn-${this.id}`);
    if (!list) return;

    list.innerHTML = '';

    const items = [
      PR_CONDITION_SUMMARIES[this.answers.q1] || 'Protocolo para condição de pele específica',
      PR_REACTION_SUMMARIES[this.answers.q5] || 'Formulação adaptada à sensibilidade da sua pele',
      this.answers.q7 === 'sim' ? 'Diagnóstico médico confirmado — protocolo alinhado ao acompanhamento' : 'Protocolo preventivo de longo prazo'
    ];

    items.forEach((text, i) => {
      setTimeout(() => {
        const li = document.createElement('li');
        li.className = 'pr-quiz__summary-item';
        li.style.animationDelay = '0ms';
        li.innerHTML = `<span class="pr-quiz__summary-check">✓</span><span>${text}</span>`;
        list.appendChild(li);

        if (i === items.length - 1 && summaryBtn) {
          setTimeout(() => summaryBtn.classList.add('visible'), 400);
        }
      }, i * 500);
    });
  }

  _fillResult() {
    const { product, url, complements, productKey } = resolveProduct(this.answers, this.c);
    const condition = this.answers.q1 || 'pele_sensivel';

    const mainName = this.c.querySelector(`#prQuizMainName-${this.id}`);
    const mainDesc = this.c.querySelector(`#prQuizMainDesc-${this.id}`);
    const resultCta = this.c.querySelector(`#prQuizResultCta-${this.id}`);
    const teamText = this.c.querySelector(`#prQuizTeamText-${this.id}`);

    if (mainName) mainName.textContent = product.name;
    if (mainDesc) mainDesc.textContent = product.desc;
    if (resultCta) {
      resultCta.dataset.productKey = productKey || '';
      resultCta.addEventListener('click', () => this._checkout(url));
    }
    if (teamText) {
      const condLabel = PR_CONDITION_LABELS[condition] || 'condições raras de pele';
      teamText.textContent = `Este protocolo foi desenvolvido para peles com ${condLabel.toLowerCase()}. Após o pedido, continue acompanhando sua evolução.`;
    }

    this._fillAnswersSummary();
    this._fillMainCard(product, url);
    this._fillComplements(complements, url);
    this._fillFaq(condition);

    const discountEmailEl = this.c.querySelector(`#prQuizDiscountEmail-${this.id}`);
    if (discountEmailEl && this.answers.email) {
      discountEmailEl.value = this.answers.email;
    }
  }

  _fillAnswersSummary() {
    const el = this.c.querySelector(`#prQuizAnswersSummary-${this.id}`);
    if (!el) return;

    const condition = PR_CONDITION_LABELS[this.answers.q1] || '';
    const reaction = PR_REACTION_SUMMARIES[this.answers.q5] || '';
    const objective = PR_OBJECTIVE_SUMMARIES[this.answers.q11] || '';

    const items = [condition, reaction, objective].filter(Boolean);
    el.innerHTML = items.map(t => `
      <div class="pr-quiz__result-answer-item">
        <span class="pr-quiz__result-answer-check">✓</span>
        <span>${t}</span>
      </div>`).join('');
  }

  _fillMainCard(product, url) {
    const el = this.c.querySelector(`#prQuizMainCard-${this.id}`);
    if (!el) return;
    el.innerHTML = `
      <div class="pr-quiz__result-product-card">
        <span class="pr-quiz__result-prod-name">${product.name}</span>
        <a href="${url}" class="pr-quiz__btn-primary" style="padding:8px 18px;font-size:13px">Ver produto</a>
      </div>`;
  }

  _fillComplements(complementKeys, mainUrl) {
    const el = this.c.querySelector(`#prQuizComplements-${this.id}`);
    const orderEl = this.c.querySelector(`#prQuizOrder-${this.id}`);
    if (!el) return;

    const activeComplements = [];
    el.innerHTML = '';

    complementKeys.forEach(key => {
      const p = PR_PRODUCT_DATA[key];
      if (!p) return;
      const compUrl = getComplementUrl(key, this.c);
      const itemId = `prComp-${this.id}-${key}`;
      const item = document.createElement('div');
      item.className = 'pr-quiz__result-complement-item';
      item.id = itemId;
      item.innerHTML = `
        <span class="pr-quiz__result-prod-name">${p.name}</span>
        <button class="pr-quiz__result-complement-remove" data-comp-id="${itemId}">Remover</button>`;
      el.appendChild(item);
      activeComplements.push({ key, name: p.name });

      item.querySelector('.pr-quiz__result-complement-remove').addEventListener('click', function() {
        item.remove();
        activeComplements.splice(activeComplements.findIndex(c => c.key === key), 1);
      });
    });

    if (el.children.length === 0) {
      el.innerHTML = '<p style="font-size:13px;color:#aaa;margin:0">Nenhum produto complementar selecionado.</p>';
    }
  }

  _fillFaq(condition) {
    const el = this.c.querySelector(`#prQuizFaqItems-${this.id}`);
    if (!el) return;

    const faqs = PR_FAQ_BY_CONDITION[condition] || PR_FAQ_BY_CONDITION.pele_sensivel;
    el.innerHTML = faqs.map(item => `
      <div class="pr-quiz__faq-item">
        <button class="pr-quiz__faq-q">
          <span>${item.q}</span>
          <span class="pr-quiz__faq-icon">+</span>
        </button>
        <p class="pr-quiz__faq-a">${item.a}</p>
      </div>`).join('');
  }

  async _checkout(mainUrl) {
    const btn = this.c.querySelector(`#prQuizResultCta-${this.id}`);
    if (btn) { btn.textContent = 'Preparando seu pedido...'; btn.disabled = true; }

    const urlsToAdd = [mainUrl];
    this.c.querySelectorAll(`#prQuizComplements-${this.id} .pr-quiz__result-complement-item`).forEach(el => {
      const key = el.id.replace(`prComp-${this.id}-`, '');
      const compUrl = getComplementUrl(key, this.c);
      if (compUrl && compUrl !== '#') urlsToAdd.push(compUrl);
    });

    try {
      const variantIds = await Promise.all(
        urlsToAdd.map(async (prodUrl) => {
          const handle = prodUrl.replace('/products/', '').split('?')[0];
          const res = await fetch(`/products/${handle}.js`);
          const data = await res.json();
          return data.variants[0].id;
        })
      );
      await fetch('/cart/clear.js', { method: 'POST' });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: variantIds.map(id => ({ id, quantity: 1 })) })
      });
      if (window.PeleRaraBrinde) await window.PeleRaraBrinde.garante();
      if (typeof endShopping === 'function') {
        endShopping();
      } else {
        window.location.href = '/checkout';
      }
    } catch (_) {
      window.location.href = mainUrl;
    }
  }

  _startCountdown() {
    const storageKey = `prq_countdown_${this.id}`;
    let endTime = parseInt(sessionStorage.getItem(storageKey) || '0', 10);
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + 39 * 60 * 1000;
      sessionStorage.setItem(storageKey, endTime);
    }
    this.countdownEnd = endTime;

    const tick = () => {
      const remaining = Math.max(0, this.countdownEnd - Date.now());
      const h = Math.floor(remaining / 3600000);
      const m = Math.floor((remaining % 3600000) / 60000);
      const s = Math.floor((remaining % 60000) / 1000);

      const pad = n => String(n).padStart(2, '0');
      const hEl = this.c.querySelector(`#prTimerH-${this.id}`);
      const mEl = this.c.querySelector(`#prTimerM-${this.id}`);
      const sEl = this.c.querySelector(`#prTimerS-${this.id}`);

      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);

      if (remaining === 0) {
        clearInterval(this.countdownInterval);
        const box = this.c.querySelector(`#prQuizCountdown-${this.id}`);
        if (box) box.style.display = 'none';
      }
    };

    tick();
    this.countdownInterval = setInterval(tick, 1000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pr-quiz').forEach(el => new PeleRaraQuiz(el));
});
